import BottomNavigation from "components/BottomNavigation"
import ImageEditor from "components/ImageEditor"
import { RadioField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  Row,
  Tooltip,
  CardHeader,
} from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import { WIDTH_TYPES } from "./constants"

const LoadingScreenLogo = ({
  change,
  formValues,
  handleNext,
  changeTab,
  handleSave,
  isDirty,
  resetForm,
  tabIsActive,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Logo</h4>
        </CardHeader>
        <CardBody>
          <Row className="mb-3">
            <Col>Logo image recommended to be minimum 1000px</Col>
          </Row>
          <Row>
            <Col>
              <Row>
                <Col xs={12} xl={2} className="my-1">
                  <label>Image:</label>
                </Col>
                <Col xs="auto" className="my-1">
                  <Field
                    name="logoImage"
                    type="file"
                    component={ImageEditor}
                    onDelete={() => change("deleteLogoImage", true)}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} xl={2}>
                  <label>Width:</label>
                </Col>
                <Col xs={12} md={10}>
                  <InputGroup className="my-2" style={{ flexWrap: "nowrap" }}>
                    <InputGroupAddon addonType="append">
                      <Field
                        name="widthType"
                        component={RadioField}
                        type="radio"
                        id={WIDTH_TYPES.PIXEL}
                        value={WIDTH_TYPES.PIXEL}
                      />
                    </InputGroupAddon>
                    <Field
                      name="widthInPixel"
                      type="number"
                      component={TextField}
                      onFocus={() => change("widthType", WIDTH_TYPES.PIXEL)}
                      min="0"
                      max="999"
                    />
                    <InputGroupAddon addonType="prepend">px</InputGroupAddon>
                  </InputGroup>

                  <InputGroup className="my-2" style={{ flexWrap: "nowrap" }}>
                    <InputGroupAddon addonType="append">
                      <Field
                        name="widthType"
                        component={RadioField}
                        type="radio"
                        value={WIDTH_TYPES.PERCENTAGE}
                      />
                    </InputGroupAddon>
                    <Field
                      name="widthInPercent"
                      type="number"
                      component={TextField}
                      onFocus={() =>
                        change("widthType", WIDTH_TYPES.PERCENTAGE)
                      }
                      min="0"
                      max="100"
                    />
                    <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                  </InputGroup>

                  <InputGroup className="my-2" style={{ flexWrap: "nowrap" }}>
                    <Field
                      name="widthType"
                      component={RadioField}
                      type="radio"
                      value={WIDTH_TYPES.FULL_WIDTH}
                      label="Full width - image goes edge to edge"
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>
                    Placement: &nbsp;
                    <i
                      className="fas fa-question-circle"
                      id="AutoHideExample"
                    ></i>
                    &nbsp;
                  </label>

                  <Tooltip
                    placement="top"
                    isOpen={tooltipOpen}
                    target="AutoHideExample"
                    toggle={toggle}
                  >
                    0% - top of the screen <br />
                    100% - bottom of the screen
                  </Tooltip>
                </Col>
                <Col>
                  <InputGroup style={{ flexWrap: "nowrap" }}>
                    <Field
                      name="logoPlacement"
                      type="number"
                      component={TextField}
                      min="0"
                      max="100"
                    />
                    <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
            </Col>
            <Col className="d-flex justify-content-end" xs="auto">
              {formValues?.logoImage && formValues?.logoImage?.editedImage && (
                <img
                  src={
                    formValues?.logoImage?.editedImage
                      ? formValues?.logoImage?.editedImage
                      : ""
                  }
                  alt="logoImage"
                  className="rounded avatar-xl"
                  style={{ height: "fit-content" }}
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <BottomNavigation
        handleBack={() => {
          changeTab()
        }}
        handleNext={handleNext}
        handleSave={handleSave}
      />
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={event => {
          handleSave(event)
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.ONBOARDING_FLOW_WIZARD)

const mapStateToProps = state => ({
  formValues: selector(state, "loadingScreen.logo"),
  isDirty: isDirty(FORM_NAMES.ONBOARDING_FLOW_WIZARD)(
    state,
    ...["loadingScreen.logo"]
  ),
})

const mapDispatchToProps = dispatch => ({
  change: (name, value) =>
    dispatch(
      change(
        FORM_NAMES.ONBOARDING_FLOW_WIZARD,
        `loadingScreen.logo.${name}`,
        value
      )
    ),
  resetForm: () => dispatch(reset(FORM_NAMES.ONBOARDING_FLOW_WIZARD)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoadingScreenLogo)
